import { render } from "./ContactsContent.vue?vue&type=template&id=68affdd0&ts=true"
import script from "./ContactsContent.vue?vue&type=script&lang=ts"
export * from "./ContactsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__